import { render, staticRenderFns } from "./StatusInput.vue?vue&type=template&id=6875a013&"
import script from "./StatusInput.vue?vue&type=script&lang=js&"
export * from "./StatusInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports